
export type IdleEvent = SystemEvent.USER_IDLE | SystemEvent.IDLE_END;

export enum SystemEvent {
    USER_IDLE,
    IDLE_END,
    WINDOW_BLUR,
    WINDOW_FOCUS,
    VIEW_RESIZE
}
